module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "padding": "0 2em 2em"
    }
  }, [_c('h4', [_vm._v("Props for Modal component and for new modal options")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-divider uk-table-small uk-table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.properties), function(prop, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "uk-width-small"
    }, [_vm._v(_vm._s(prop.name))]), _vm._v(" "), _c('td', {
      staticClass: "uk-width-small"
    }, [_c('small', [_vm._v(_vm._s(prop.type))])]), _vm._v(" "), _c('td', {
      staticClass: "uk-width-small"
    }, [_vm._v(_vm._s(prop.default))]), _vm._v(" "), _c('td', {
      staticClass: "uk-width-small"
    }, [_vm._v(_vm._s(prop.accepted))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(prop.description))])])
  }))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0 2em 2em"
    }
  }, [_c('h4', [_vm._v("Add props for new modal options")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table uk-table-divider  uk-table-small"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.addProperties), function(prop, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "uk-width-small"
    }, [_vm._v(_vm._s(prop.name))]), _vm._v(" "), _c('td', {
      staticClass: "uk-width-small"
    }, [_c('small', [_vm._v(_vm._s(prop.type))])]), _vm._v(" "), _c('td', {
      staticClass: "uk-width-small"
    }, [_vm._v(_vm._s(prop.default))]), _vm._v(" "), _c('td', {
      staticClass: "uk-width-small"
    }, [_vm._v(_vm._s(prop.accepted))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(prop.description))])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Property")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Accepted")]), _vm._v(" "), _c('th', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Property")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Accepted")]), _vm._v(" "), _c('th', [_vm._v("Description")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea954fdc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/pages/props.vue
// module id = 225
// module chunks = 1